import { render } from "./DreamsPrayers.vue?vue&type=template&id=1b75b002"
import script from "./DreamsPrayers.vue?vue&type=script&lang=js"
export * from "./DreamsPrayers.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__